import React, { ReactNode } from "react";
import { RenderAuthentication } from "@shared/contexts";
import { RenderAccount } from "@shared/contexts";
import { RenderOnBoarding } from "@shared/contexts";

interface RouteWrapperProps {
  children: ReactNode;
}

export const AuthenticationRoute: React.FC<RouteWrapperProps> = ({ children }) => {
  return (
    <RenderAuthentication>
      {children}
    </RenderAuthentication>
  );
};

export const CreateAccountRoute: React.FC<RouteWrapperProps> = ({ children }) => {
  return (
    <RenderAccount>
      {children}
    </RenderAccount>
  );
};

export const OnBoardingRoute: React.FC<RouteWrapperProps> = ({ children }) => {
  return (
    <RenderOnBoarding>
      {children}
    </RenderOnBoarding>
  );
};

// Service terms don't need wrapping
export const ServiceTermsRoute: React.FC<RouteWrapperProps> = ({ children }) => {
  return <>{children}</>;
};
